
<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable
  class="material striped datatable"
  [rows]="displayItems"
  [columnMode]="'force'"
  [headerHeight]="40"
  [footerHeight]="20"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [rowHeight]="40"
  [reorderable]="true"
>


  <ngx-datatable-column prop="name" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Game Date
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{ row.date | date: "EEEE, MMMM d, y, h:mm:ss a zzzz" }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="numberOfPlayers" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Number of Players
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>
        {{ row.numberOfPlayers }}
      </span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="numberOfWinners" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Number of Winners
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>
        {{ row.numberOfWinners }}
      </span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="file" [sortable]="false">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Result Details
      </span>
    </ng-template>
    <ng-template
      let-row="row"
      let-rowIndex="rowIndex"
      ngx-datatable-cell-template
    >
    <button (click)="viewDetails(row.serviceId, row.triviaGameId, row.serviceLogId)">View</button>
    <button (click)="downloadDetails(row)">Download</button>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

<button (click)="back()" class="btn btn-success" style="margin-top:10px; float:left">Back to Trivia Game</button>
